import React from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
export function DifferenceSection() {
  return <section id="difference" className="py-16 md:py-24 bg-[#2D5A27] text-white relative overflow-hidden" data-id="element-36">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-37"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-39">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#C5A55A]/20 text-[#C5A55A] mb-6" data-id="element-40">
            <Award className="w-8 h-8" data-id="element-41" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-42">
            THE DIFFERENCE THAT CHANGES EVERYTHING
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto rounded-full" data-id="element-43"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-center" data-id="element-44">
          <p className="font-semibold text-2xl text-[#C5A55A]" data-id="element-45">
            RMorales Lawn Service LLC is not "just some guy with a mower."
          </p>

          <p className="text-gray-200" data-id="element-46">
            It's a legally registered company in the state of Texas.
          </p>

          <p className="text-gray-200" data-id="element-47">
            An LLC with a name, with accountability, and with a team that shows
            up on the day they say they'll show up.
          </p>

          <p className="text-gray-200" data-id="element-48">
            We've been transforming properties in{' '}
            <span className="font-semibold text-white" data-id="element-49">
              Katy, Cypress, Rosenberg, Richmond, Fulshear, and Sealy
            </span>{' '}
            for years.
          </p>

          <div className="mt-12 p-8 border-2 border-[#C5A55A]/30 rounded-2xl bg-[#1B2E1B]/50 backdrop-blur-sm" data-id="element-50">
            <p className="text-gray-300 mb-4 uppercase tracking-widest text-sm font-bold" data-id="element-51">
              Our Single Mission
            </p>
            <p className="text-2xl md:text-3xl font-bold text-white italic" data-id="element-52">
              "To make you pull into your driveway and feel proud."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}